// Types for actions and reducer in hermes
export const APP_MAINTENANCE_LOADING = "App Maintenance loading";
export const APP_MAINTENANCE_SUCCESS = "App Maintenance success";
export const APP_MAINTENANCE_ERROR = "App Maintenance error";
export const GET_COMISSIONS_LOADING = "Get Comissions loading";
export const GET_COMISSIONS_SUCCESS = "Get Comissions success";
export const GET_COMISSIONS_ERROR = "Get Comissions error";
export const POST_PAYMENT_LOADING = "Post Payment loading";
export const POST_PAYMENT_SUCCESS = "Post Payment success";
export const POST_PAYMENT_ERROR = "Post Payment error";
export const POST_CHECKOUT_LOADING = "Post Checkout loading";
export const POST_CHECKOUT_SUCCESS = "Post Checkout success";
export const POST_CHECKOUT_ERROR = "Post Checkout error";
export const GET_CVV_LOADING = "Get cvv loading";
export const GET_CVV_SUCCESS = "Get cvv success";
export const GET_CVV_ERROR = "Post cvv error";
export const POST_FORM_LOADING = "Post Form loading";
export const POST_FORM_SUCCESS = "Post Form success";
export const POST_FORM_ERROR = "Post Form error";
export const GET_CAPTURE_LINE_DATA_LOADING = "get capture line data loading";
export const GET_CAPTURE_LINE_DATA_SUCCESS = "get capture line data success";
export const GET_CAPTURE_LINE_DATA_ERROR = "get capture line data error";
export const CLEAN_STATE = "Clean state success";
export const PAYMENT_SERVICE_LOADING = "Payment service loading";
export const PAYMENT_SERVICE_SUCCESS = "Payment service success";
export const PAYMENT_SERVICE_ERROR = "Payment service error";
export const DELETE_PENDING_TRANSACTIONS_LOADING =
  "Delete pending transactions loading";
export const DELETE_PENDING_TRANSACTIONS_SUCCESS =
  "Delete pending transactions success";
export const DELETE_PENDING_TRANSACTIONS_ERROR =
  "Delete pending transactions error";
export const VERIFY_PAYMENT_SERVICE_LOADING = "Verify payment service loading";
export const VERIFY_PAYMENT_SERVICE_SUCCESS = "Verify payment service success";
export const VERIFY_PAYMENT_SERVICE_ERROR = "Verify payment service error";
export const STATUS_TRANSACTION_LOADING = "Status transaction loading";
export const STATUS_TRANSACTION_ERROR = "Status transaction error";
export const STATUS_TRANSACTION_SUCCESS = "Status transaction success";
export const VALIDATE_TRANSACTION_LOADING = "Validate transaction loading";
export const VALIDATE_TRANSACTION_SUCCESS = "Validate transaction success";
export const VALIDATE_TRANSACTION_ERROR = "Validate transaction error";
export const AUTHENTICATION_3DS_LOADING = "Authentication 3ds loading";
export const AUTHENTICATION_3DS_SUCCESS = "Authentication 3ds success";
export const AUTHENTICATION_3DS_ERROR = "Authentication 3ds error";
export const STATE_AUTHENTICATION_3DS_LOADING =
  "State authentication 3ds loading";
export const STATE_AUTHENTICATION_3DS_SUCCESS =
  "State authentication 3ds success";
export const STATE_AUTHENTICATION_3DS_ERROR = "State authentication 3ds error";
export const CDMX_STATUS_PAYMENT_LOADING = "Cdmx status payment loading";
export const CDMX_STATUS_PAYMENT_SUCCESS = "Cdmx status payment success";
export const CDMX_STATUS_PAYMENT_ERROR = "Cdmx status payment error";
export const GET_CDMX_PAGE_LOADING = "Get cdmx page loading";
export const GET_CDMX_PAGE_SUCCESS = "Get cdmx page success";
export const GET_CDMX_PAGE_ERROR = "Get cdmx page error";
export const UPDATE_PENDING_TRANSACTION_LOADING = "Update pending transaction loading";
export const UPDATE_PENDING_TRANSACTION_SUCCESS = "Update pending transaction success";
export const UPDATE_PENDING_TRANSACTION_ERROR = "Update pending transaction error";
export const VALIDATE_CDMX_DATA_LOADING = "Validate CDMX data loading";
export const VALIDATE_CDMX_DATA_SUCCESS = "Validate CDMX data success";
export const VALIDATE_CDMX_DATA_ERROR = "Validate CDMX data error";
